<template>
  <el-drawer
    :visible.sync="visi"
    :with-header="false"
    direction="btt"
    size="80%">
    <div class="tabs">
      <a
        v-for="item in tabs"
        :key="item.id"
        :class="{'active': tabActive == item.id}"
        @click="tabClick(item.id)">
        {{item.name}}
      </a>
    </div>
    <div 
      class="msg"
      v-loading="loading">
      <p class="no-data">暂无消息</p>
    </div>
    <div class="footer">
      <a>一键已读</a>
    </div>
  </el-drawer>
</template>

<script>
import { GetMessageList } from '@/api'
import { withLoadingApi } from '@/utils/hoc'
export default {
  data () {
    return {
      visi: false,
      tabActive: 1,
      tabs: [{
        id: 1,
        name: '未读消息',
      },
      {
        id: 2,
        name: '已读消息',
      },
      {
        id: 3,
        name: '全部消息',
      }],

      page: 1,
      res: {},
      list: [],

      loading: false
    }
  },
  methods: {
    show(){
      this.visi = true
    },
    tabClick(id){
      this.tabActive = id;
    },
    initData(){
      withLoadingApi(
        GetMessageList({
          page: this.page,
          is_read: this.tabActive == 3 ? null : this.tabActive,
          limit: 30
        }),
        'loading',
        this
      ).then(res => {
        this.res = res;
        this.list = this.page > 1
        ? [...this.list, ...res.list]
        : res.list;
      })
    }
  },
  mounted(){
    //初始化消息列表
    this.initData();
  }
}
</script>

<style lang="scss" scoped>
>>>.el-drawer__body{
  padding: 0;
  flex-direction: column;
}
.tabs{
  display: flex;
  a{
    flex: 1;
    font-size: 1.1375rem;
    text-align: center;
    height: 3.5rem;
    line-height: 3.5rem;
    position: relative;
    &.active{
      color: $theme-color;
    }
  }
  a:nth-child(2){
    &::before,
    &::after{
      content: '';
      display: block;
      width: 0.0875rem;
      height: 1.4rem;
      background: #ebebeb;
      position: absolute;
      top: 1.05rem;
    }
    &::after{
      right: 0;
    }
  }
}
.msg{
  flex: 1;
  border-top: 0.0875rem solid #ebebeb;

  .no-data{
    text-align: center;
    color: $text3;
    font-size: 1.1375rem;
    margin-top: 17.5rem;
  }
}
.footer{
  height: 3.5rem;
  border-top: 0.0875rem solid #ebebeb;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 1.4rem;
  a{
    font-size: 1.12rem;
    color: $theme-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/User/Message/index.vue